export default __webpack_public_path__ + "static/media/thank_you_group.b5215c09.png";